import { Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import CommonModal from '../../../../Components/Common/CommonModal';
import { imgUrl } from '../../../../Helpers/Constant';
import { PaymentRecord } from '../../apiEndpoints/exhibitorType';

const InvoicePayment = ({
  PaymentRecord,
}: {
  PaymentRecord: PaymentRecord[] | undefined;
}) => {
  return (
    <div className='table-responsive'>
      <h6 className='mb-3 text-primary'>Client Invoice Payment</h6>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>SL.</th>
            <th>Payment Date</th>
            <th>Deposit Date</th>
            <th>Payment Type</th>
            <th>Bank Account</th>
            <th>Bank Name</th>
            <th>Branch Name</th>
            <th>Bank Slip</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {PaymentRecord && PaymentRecord?.length > 0 ? (
            PaymentRecord?.map((row, index) => (
              <tr key={row.id}>
                <td>{index + 1}</td>
                <td>{dayjs(row.payment_date).format('DD-MMM-YYYY')}</td>
                <td>{dayjs(row.deposit_date).format('DD-MMM-YYYY')}</td>
                <td>{row.payment_type}</td>
                <td>{row.bank_ac_no}</td>
                <td>{row.bank_name}</td>
                <td>{row.branch_name}</td>
                <td align='center'>
                  <CommonModal showView modalTitle='Image Preview' modalOff>
                    <img
                      src={`${imgUrl}/${row.bank_slip}`}
                      alt={row.bank_slip}
                      width={'100%'}
                      height={400}
                    />
                  </CommonModal>
                </td>
                <td>{row.amount}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={9} className='text-center'>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default InvoicePayment;
